import FilterSection, { FilterrSectionProps } from "../filter/FilterSection";
import { SelectOption } from "../../search-avaliable/SearchAvailableRoom";

export interface IPopularImage {
  id: string;
  src: string;
  alt?: string;
  caption?: string;
  title: string;
  name: string;
  url: string;
  urlTarget: "_self" | "_blank" | "_parent" | "_top" | undefined;
}

interface PopularSectionProps extends FilterrSectionProps {
  isShowFilterBannerPage?: boolean | null;
  isHotelListPage?: boolean;
  listOption: SelectOption[] | { label: string; options: SelectOption[] }[];
  SetSubmitClicked: React.Dispatch<React.SetStateAction<boolean>>;
  isHotelOnSenPage?: boolean;
  isFirstCityChange?: React.MutableRefObject<boolean>;
}
const PopularSection: React.FC<PopularSectionProps> = ({
  benefitList,
  brandList,
  onFilterChange,
  filterState,
  defaultValue,
  currentBrand,
  isMapView,
  setIsMapView,
  isShowFilterBannerPage,
  isHotelListPage,
  listOption,
  SetSubmitClicked,
  isHotelOnSenPage,
  currentTag,
  hotelSliderSections,
  isFirstCityChange,
}: PopularSectionProps) => {
  return (
    <div className={`relative w-full`}>
      <div
        className={`flex flex-col items-center justify-between md:flex-row md:gap-2`}
      >
        <FilterSection
          benefitList={benefitList}
          brandList={brandList}
          SetSubmitClicked={SetSubmitClicked}
          onFilterChange={onFilterChange}
          filterState={filterState}
          defaultValue={defaultValue}
          currentBrand={currentBrand}
          isMapView={isMapView}
          setIsMapView={setIsMapView}
          isShowFilterBannerPage={isShowFilterBannerPage}
          listOption={listOption}
          isHotelListPage={isHotelListPage}
          isHotelOnSenPage={isHotelOnSenPage}
          currentTag={currentTag}
          hotelSliderSections={hotelSliderSections}
          isFirstCityChange={isFirstCityChange}
        />
      </div>
    </div>
  );
};

export default PopularSection;
